import {
  Box,
  Typography,
  Slider,
  CircularProgress,
  useMediaQuery,
} from "@mui/material";
import { CustomButton } from "../../../../v2/MUI_custom_component";
import { useState } from "react";
import GlassModal from "../../../../v2/MUI_custom_component/Modal/GlassModal";
import OTPVerificationComponent from "../../../Beneficiary/Gap/Components/OTPVerificationComponent";
import { toast } from "react-toastify";
import { sendOTPAction, verifyOTPAction } from "../APIs/action";
import CustomChip from "../../../Components/CustomChip";
import {
  downloadAction,
  handleDownload,
} from "../../../Common/Download Button/downloadAction";
import { downloadTripVoucherUrl } from "../APIs/urls";
import { useSelector } from "react-redux";
// import { encryptPassword } from "../../../../v2/Utils/Encryption/NodeForgeEncryption";

export const VoucherCard = ({ voucherData }) => {
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedEntity: selectedCompanyEntity } = useSelector(
    (state) => state.entityReducer,
  );
  // const userId = useSelector((state) => state.loginReducer.loginUser?.user_id);
  const isMobile = useMediaQuery("(max-width: 1200px)");

  const handleDownloadVoucher = async () => {
    setOpenVerifyModal(true);
    await handleResendOTP(voucherData.mobile_no_registered_for_voucher);
    //   {
    //   mobile_no: encryptPassword(voucherData.mobile_no_registered_for_voucher),
    //   purpose: "VERIFICATION",
    //   user_id: encryptPassword(String(userId)),
    // }
  };

  const handleResendOTP = async (payload) => {
    const { error, message } = await sendOTPAction(payload);
    if (!error) {
      return { success: true, message };
    } else {
      toast.error(message || "Failed to send OTP");
      return { success: false, message };
    }
  };

  const handleVerifyOTP = async (otpValue) => {
    // const payload = {
    //   mobile_number: encryptPassword(
    //     voucherData.mobile_no_registered_for_voucher,
    //   ),
    //   otp: encryptPassword(otpValue),
    //   purpose: "VERIFICATION",
    //   user_id: encryptPassword(String(userId)),
    // };
    const { data, error, message } = await verifyOTPAction(
      voucherData.mobile_no_registered_for_voucher,
      otpValue,
    );
    if (!error) {
      return { data, error, message };
    } else {
      return { success: false, message };
    }
  };

  const handleVerifySuccess = () => {
    if (isLoading) return;
    setOpenVerifyModal(false);
    setIsLoading(true);
    const showToast = "Voucher downloaded successfully!";
    const queryParams = new URLSearchParams();
    queryParams.append("company_esi_id", selectedCompanyEntity);
    queryParams.append("voucher_id", voucherData?.voucher_id);
    handleDownload(
      () => downloadAction(downloadTripVoucherUrl, queryParams, "Voucher.pdf"),
      setIsLoading,
      showToast,
    );
  };

  return (
    <>
      <Box
        sx={{
          padding: 1,
          borderRadius: 2,
          background:
            "radial-gradient(72.21% 89.9% at 75.56% 10.1%, rgba(255, 165, 37, 0.105) 29.33%, rgba(0, 129, 242, 0.15) 93.27%)",
          display: "flex",
          flexDirection: "column",
          gap: isMobile ? 1 : 2,
        }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "342 / 117",
            borderRadius: 2,
            overflow: "hidden",
          }}>
          <Box
            component="img"
            src={voucherData?.image_url}
            alt="Voucher"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
              display: "block",
            }}
          />
          <CustomChip
            key={voucherData?.date}
            label={voucherData?.date}
            variant="filled"
            sx={{ position: "absolute", top: 8, right: 8 }}
            selected={true}
            size={isMobile ? "small" : "medium"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: isMobile ? 1 : 2,
            alignItems: "flex-end",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              minWidth: 0,
            }}>
            <Typography
              variant="overline"
              sx={{
                color: "#666",
                fontWeight: "400",
                lineHeight: "20px",
                letterSpacing: "0px",
              }}>
              {voucherData?.voucher_utilisation_info?.display_label}
            </Typography>
            <Typography variant="h2" sx={{ color: "#995A00" }}>
              {voucherData?.voucher_utilisation_info?.value}%
            </Typography>
          </Box>
          <CustomButton
            variant="filled"
            color="primary"
            size={isMobile ? "small" : "medium"}
            disabled={
              isLoading || voucherData?.voucher_utilisation_info?.value === 100
            }
            label={
              isLoading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} />
                  <span>Downloading...</span>
                </Box>
              ) : (
                "Download Voucher"
              )
            }
            onClick={handleDownloadVoucher}
          />
        </Box>
        <Slider
          step={10}
          min={0}
          max={100}
          value={voucherData?.voucher_utilisation_info?.value || 0}
          sx={{
            height: "8px",
            color: "#FFA525",
            padding: "4px 0 !important", // override all default and touch padding
            m: 0,
            "& .MuiSlider-thumb": {
              backgroundColor: "#fff",
              height: "12px",
              width: "12px",
              transition: "none", // removes thumb animation
              cursor: "none", // removes pointer cursor on thumb
              "&:hover": {
                boxShadow: "none", // removes hover ripple/glow
              },
              "&.Mui-active": {
                boxShadow: "none", // removes active/click ripple
              },
              "&.Mui-focusVisible": {
                boxShadow: "none", // removes focus ring
              },
            },
            "& .MuiSlider-track": {
              transition: "none", // removes track animation
            },
            "& .MuiSlider-rail": { transition: "none" },
          }}
        />
      </Box>
      <GlassModal
        open={openVerifyModal}
        onClose={() => setOpenVerifyModal(false)}
        title="Enter OTP"
        maxWidth="560px"
        maxHeight="30%">
        <OTPVerificationComponent
          mobileNumber={voucherData.mobile_no_registered_for_voucher}
          onVerify={handleVerifyOTP}
          onResend={() =>
            handleResendOTP(voucherData.mobile_no_registered_for_voucher, true)
          }
          otpLength={4}
          initialTimer={60}
          showMobileNumber
          onAnimationComplete={handleVerifySuccess}
        />
      </GlassModal>
    </>
  );
};
